const theme = {
  // ${({ theme }) => theme.colors.컬러이름};
  colors: {
    white: '#FFFFFF',
    lightOrange: '#FFF6EC',
    mediumOrange: '#EDCDA7',
    orange: '#FF8B00',
    lightBrown: '#7B3400',
    brown: '#947A6B',
    darkBrown: '#2D1800',
    lightGray: '#EAEAEA',
    gray: '#BBBBBB',
    darkGray: '#8F8F8F',
  },

  // ${({ theme }) => theme.background.배경이름};
  background: {
    mainBackground: 'linear-gradient(#2C1900, #001E17)',
    header: 'linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.1))',
  },
};

export default theme;
